import { authServiceAxiosClient } from '@/lib';
import { withLogger } from '@/utils';

import { globalLetterAPIUrls } from '../data';
import { EmailTemplate } from '../types';

type EmailTemplateResponse = {
  success: boolean;
  message: string;
  data: Array<EmailTemplate>;
};

type Return = Array<EmailTemplate>;

export type GetEmailTemplate = {
  response: EmailTemplateResponse;
  return: Return;
};

export const getEmailTemplates = withLogger(async (): Promise<Return> => {
  const url = globalLetterAPIUrls.emailTemplate.fetch;

  const {
    data: { data },
  } = await authServiceAxiosClient.get<EmailTemplateResponse>(url);

  return data;
});
